var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd3a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa68d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.924,
    x2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5699",
    "data-name": "Group 5699",
    transform: "translate(-257 -328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4773",
    "data-name": "Path 4773",
    d: "M3.287-5.655H7.58v3.1H3.287V2.3H.016V-2.551H-4.29v-3.1H.016v-4.65H3.287Z",
    transform: "translate(271.289 348.305)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M2798-3109a15.9,15.9,0,0,1-11.314-4.687A15.894,15.894,0,0,1,2782-3125a15.9,15.9,0,0,1,4.686-11.314A15.9,15.9,0,0,1,2798-3141a15.9,15.9,0,0,1,11.314,4.686A15.9,15.9,0,0,1,2814-3125a15.894,15.894,0,0,1-4.687,11.313A15.9,15.9,0,0,1,2798-3109Zm0-29a13.015,13.015,0,0,0-13,13,13.015,13.015,0,0,0,13,13,13.014,13.014,0,0,0,13-13A13.015,13.015,0,0,0,2798-3138Z",
    transform: "translate(-2525 3469)",
    fill: "url(#linear-gradient-2)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusButton);
export default __webpack_public_path__ + "static/media/plus-button.89dbba5921a07b87173b60afaf3fa652.svg";
export { ForwardRef as ReactComponent };